import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBaY9mDr1NwjxZcwUmRjY9pRqUjIJlA6zU",
  authDomain: "webrtc-signaling-aa3b4.firebaseapp.com",
  projectId: "webrtc-signaling-aa3b4",
  storageBucket: "webrtc-signaling-aa3b4.appspot.com",
  messagingSenderId: "422313915359",
  appId: "1:422313915359:web:bb3a62a9713f3628e18a6a",
  measurementId: "G-97LN7FFRMV",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const firestore = firebase.firestore();

export default firestore;
